import PlusIcon from '../../common/icons/PlusIcon';
import CheckIcon from '../../common/icons/CheckIcon';
import colors from 'tailwindcss/colors';

interface Props {
  remainingOffers: number;
  hasUnselectedOffers: boolean;
}

export function Notification({ remainingOffers, hasUnselectedOffers }: Props) {
  const isShowRemainingOffers = remainingOffers > 0 && !hasUnselectedOffers;

  return (
    <div
      className={`GiftBox-LauncherNotification absolute top-0 text-white flex justify-center items-center rounded-full ${
        isShowRemainingOffers ? 'backgroundOutBadge' : 'backgroundInBadge'
      }`}
      data-cy="notification"
    >
      <span
        className={`badgeNumber ${
          isShowRemainingOffers ? 'badgeNumberIn' : 'badgeNumberOut'
        } absolute`}
      >
        {remainingOffers}
      </span>

      <span
        className={`${
          hasUnselectedOffers ? 'statusIconIn' : 'statusIconOut'
        }  opacity-0 `}
      >
        {hasUnselectedOffers && <PlusIcon color={colors.white} />}
      </span>

      <span
        className={`${
          !hasUnselectedOffers && remainingOffers === 0
            ? 'statusIconIn'
            : 'statusIconOut'
        }  opacity-0 `}
      >
        {!hasUnselectedOffers && remainingOffers === 0 && (
          <CheckIcon color={colors.white} />
        )}
      </span>
    </div>
  );
}
